import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Routes, ActivatedRoute, Router } from '@angular/router';
import { AuditService } from 'app/audit/services/audit.service';
import { AuditTemplateService } from 'app/audit-template/services/audit-template.service';
import { ModuleModel } from 'app/audit/models/module.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Result } from 'app/core/models/result';

@Component({
  selector: 'app-audit-template-module-add',
  templateUrl: './audit-template-module-add.component.html',
  styleUrls: ['./audit-template-module-add.component.css']
})
export class AuditTemplateModuleAddComponent implements OnInit {
    errors: string[];
    @Input() auditTemplateId: string;
    @Output() auditTemplateModuleAdded: EventEmitter<string> = new EventEmitter<string>();
    modules: ModuleModel[];
    addModuleForm: FormGroup;
    submitAttempt: boolean = false;

    constructor(
        private router: Router,
        private auditService: AuditService,
        private auditTemplateService: AuditTemplateService,
        private fb: FormBuilder
    ) { }

    ngOnInit() {
        this.getModules();
        this.initializeForm();
    }

    initializeForm(): void {
        this.addModuleForm = this.fb.group({
            auditTemplateId: [this.auditTemplateId],
            moduleId: ['', Validators.required],
            isMandatory: [false],
            isSingular: [false]
        });
    }

    getModules(): void {
        this.auditService.getModules().subscribe(result => {
            this.modules = result;
        });
    }

    get isMandatory() { return this.addModuleForm.get('isMandatory'); }
    get isSingular() { return this.addModuleForm.get('isSingular'); }


    addModuleToAuditTemplate(): void {
        this.submitAttempt = true;
        if (this.addModuleForm.valid) {
            const formValue = this.addModuleForm.value;
            this.auditTemplateService.addModuleToAuditTemplate(formValue).subscribe(
                result => {
                    this.auditTemplateModuleAdded.emit(result);
                    //this.addModuleForm.reset();
                    this.initializeForm();
                    this.submitAttempt = false;
                    this.router.navigate(['./audit-template/audit-template-modules/', this.auditTemplateId]);
                },
                error => {
                    this.errors = (<Result>error).errorList;
                    this.submitAttempt = false;
                }
            );
        }
    }

}
